export const TYPOGRAPHY_INVENTORY = [
  {
    id: 'headings',
    label: 'Headings',
    description: 'Main page and section titles (h1-h6)',
    defaultFontSize: '1.5',  // rem
    defaultFontWeight: 'bold',  // 'normal' or 'bold'
  },
  {
    id: 'columnHeadings',
    label: 'Column Headings',
    description: 'Table column headers',
    defaultFontSize: '0.875',
    defaultFontWeight: 'bold',
  },
  {
    id: 'subheadings',
    label: 'Subheadings',
    description: 'Secondary titles and subtitles',
    defaultFontSize: '1.125',
    defaultFontWeight: 'normal',
  },
  {
    id: 'labels',
    label: 'Labels',
    description: 'Form field labels and captions',
    defaultFontSize: '0.875',
    defaultFontWeight: 'normal',
  },
  {
    id: 'toastText',
    label: 'Toast Text',
    description: 'Notification toast messages',
    defaultFontSize: '0.875',
    defaultFontWeight: 'normal',
  },
  {
    id: 'body',
    label: 'Body',
    description: 'General body text and paragraphs',
    defaultFontSize: '0.875',
    defaultFontWeight: 'normal',
  },
  {
    id: 'field',
    label: 'Field',
    description: 'Form field input values',
    defaultFontSize: '0.875',
    defaultFontWeight: 'normal',
  },
  {
    id: 'cell',
    label: 'Cell',
    description: 'Table cell content',
    defaultFontSize: '0.875',
    defaultFontWeight: 'normal',
  },
  {
    id: 'captions',
    label: 'Captions',
    description: 'Small caption text, help text, secondary labels',
    defaultFontSize: '0.875',
    defaultFontWeight: 'normal',
  },
];
